package com.nonopn.skywatcher.common.app.pages.administrators

import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.page_administrators_add_new_administrator_couldnt_invite_text
import com.nonopn.skywatcher.common.app.res.page_administrators_add_new_administrator_couldnt_invite_title
import com.nonopn.skywatcher.common.app.res.page_administrators_add_new_administrator_text
import com.nonopn.skywatcher.common.app.res.page_administrators_add_new_administrator_title
import com.nonopn.skywatcher.common.app.res.page_administrators_cant_invite
import com.nonopn.skywatcher.common.app.res.page_administrators_couldnt_load
import com.nonopn.skywatcher.common.app.res.page_administrators_remove_administrator_couldnt_remove_text
import com.nonopn.skywatcher.common.app.res.page_administrators_remove_administrator_text
import com.nonopn.skywatcher.common.app.res.page_administrators_remove_administrator_title
import com.nonopn.skywatcher.common.app.res.page_users_add_new_user_couldnt_invite_text
import com.nonopn.skywatcher.common.app.res.page_users_add_new_user_couldnt_invite_title
import com.nonopn.skywatcher.common.app.res.page_users_add_new_user_text
import com.nonopn.skywatcher.common.app.res.page_users_add_new_user_title
import com.nonopn.skywatcher.common.app.res.page_users_cant_invite
import com.nonopn.skywatcher.common.app.res.page_users_couldnt_load
import com.nonopn.skywatcher.common.app.res.page_users_remove_user_couldnt_remove_text
import com.nonopn.skywatcher.common.app.res.page_users_remove_user_text
import com.nonopn.skywatcher.common.app.res.page_users_remove_user_title
import org.jetbrains.compose.resources.StringResource

data class LocaleHolder(
    val add_new_user_title: StringResource,
    val add_new_user_text: StringResource,
    val remove_user_title: StringResource,
    val remove_user_text: StringResource,
    val add_new_user_couldnt_invite_title: StringResource,
    val add_new_user_couldnt_invite_text: StringResource,
    val remove_user_couldnt_remove_text: StringResource,
    val cant_invite: StringResource,
    val couldnt_load: StringResource,
)

val UserLocalHolder = LocaleHolder(
    add_new_user_title = Res.string.page_users_add_new_user_title,
    add_new_user_text = Res.string.page_users_add_new_user_text,
    remove_user_title = Res.string.page_users_remove_user_title,
    remove_user_text = Res.string.page_users_remove_user_text,
    add_new_user_couldnt_invite_title = Res.string.page_users_add_new_user_couldnt_invite_title,
    add_new_user_couldnt_invite_text = Res.string.page_users_add_new_user_couldnt_invite_text,
    remove_user_couldnt_remove_text = Res.string.page_users_remove_user_couldnt_remove_text,
    cant_invite = Res.string.page_users_cant_invite,
    couldnt_load = Res.string.page_users_couldnt_load,
)

val AdministratorLocalHolder = LocaleHolder(
    add_new_user_title = Res.string.page_administrators_add_new_administrator_title,
    add_new_user_text = Res.string.page_administrators_add_new_administrator_text,
    remove_user_title = Res.string.page_administrators_remove_administrator_title,
    remove_user_text = Res.string.page_administrators_remove_administrator_text,
    add_new_user_couldnt_invite_title = Res.string.page_administrators_add_new_administrator_couldnt_invite_title,
    add_new_user_couldnt_invite_text = Res.string.page_administrators_add_new_administrator_couldnt_invite_text,
    remove_user_couldnt_remove_text = Res.string.page_administrators_remove_administrator_couldnt_remove_text,
    cant_invite = Res.string.page_administrators_cant_invite,
    couldnt_load = Res.string.page_administrators_couldnt_load,
)
